import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import '../css/Form.css'; // Import your CSS styles

const ResetPassword = () => {
  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false); // Loading state for buttons
  const [resendTimer, setResendTimer] = useState(50); // Timer for resend OTP
  const [resendEnabled, setResendEnabled] = useState(false); // Resend OTP button state
  const location = useLocation();
  const navigate = useNavigate();
  const { email } = location.state; // Get email from previous page

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');
    setIsLoading(true);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/forgetPassword`, {
        email,
        otp,
        password,
      });

      if (response.status === 200) {
        setSuccessMessage('Password reset successfully! Redirecting to login...');
        setTimeout(() => navigate('/login'), 2000);
      } else {
        setError('Failed to reset password. Please check your OTP and try again.');
      }
    } catch (error) {
      console.error('Error resetting password:', error);
      setError('Failed to reset password. Please check your OTP and try again.');
    } finally {
      setIsLoading(false);
    }
  };

  // Handle OTP resend
  const handleResendOtp = async () => {
    setError('');
    setSuccessMessage('');
    setIsLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/auth/resendOtp?email=${encodeURIComponent(email)}`
      );

      if (response.status === 200) {
        setSuccessMessage('OTP resent successfully!');
        setResendEnabled(false); // Disable resend button again
        setResendTimer(50); // Reset timer
      } else {
        setError('Failed to resend OTP. Please try again.');
      }
    } catch (error) {
      console.error('Error resending OTP:', error);
      setError('Failed to resend OTP. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  // Timer effect for resend OTP button
  useEffect(() => {
    if (resendTimer > 0) {
      const timer = setInterval(() => {
        setResendTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(timer); // Cleanup on component unmount
    } else {
      setResendEnabled(true); // Enable resend button after timer ends
    }
  }, [resendTimer]);

  return (
    <div className="form-container">
      <div className="form-wrapper">
        <h2>Reset Password</h2>
        <form onSubmit={handleSubmit}>
          <p>Email: <strong>{email}</strong></p>
          <div className="input-group">
            <input
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              required
            />
          </div>
          <div className="input-group">
            <input
              type="password"
              placeholder="Enter New Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          {successMessage && <div className="success-message">{successMessage}</div>}
          <button type="submit" className="submit-btn" disabled={isLoading}>
            {isLoading ? 'Processing...' : 'Reset Password'}
          </button>
        </form>
        <button
          type="button"
          className={`resend-otp-btn ${resendEnabled ? '' : 'disabled'}`}
          disabled={!resendEnabled}
          onClick={handleResendOtp}
        >
          {resendEnabled ? 'Resend OTP' : `Resend OTP (${resendTimer}s)`}
        </button>
      </div>
    </div>
  );
};

export default ResetPassword;
